import { render, staticRenderFns } from "./price_offer.vue?vue&type=template&id=a6664b24&scoped=true"
import script from "./price_offer.vue?vue&type=script&lang=js"
export * from "./price_offer.vue?vue&type=script&lang=js"
import style0 from "./price_offer.vue?vue&type=style&index=0&id=a6664b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6664b24",
  null
  
)

export default component.exports